var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "app-container" }, [_c('el-tabs', { attrs: { "type": "border-card" }, on: { "tab-click": _vm.handleTabClick }, model: { value: _vm.currentTag, callback: function callback($$v) {
        _vm.currentTag = $$v;
      }, expression: "currentTag" } }, _vm._l(_vm.tabs, function (tab) {
    return _c('el-tab-pane', { key: tab.key, attrs: { "label": tab.label, "name": tab.key } }, [_vm.currentTag == tab.key ? _c('list-table', { attrs: { "type": tab.key } }) : _vm._e()], 1);
  }), 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };